import React from 'react';
import Iframe from '../../components/Iframe';

export const Documentation = () => (
    <Iframe
        title="documentation"
        src={process.env.REACT_APP_DOCUMENTATION_URL}
    />
)
export default Documentation;